import { createActionGroup, emptyProps, props } from '@ngrx/store'

import {
  GenerateDataModelResponse,
  GenerateDocTemplateResponse,
  GenerateEnumerationResponse,
  GenerateImageResponse,
  GenerateNotTemplateResponse,
  GenerateSubstTagsResponse,
} from '@flowx/designer/modules/new-ai/agents/architect/api/architect.api'
import { SendFeedbackPayload } from '@flowx/designer/modules/new-ai/common/ai.dictionary'

const errorProps = props<{ statusCode: number; errorMsg?: any }>

export const AiArchitectActions = createActionGroup({
  source: 'AiArhitect',
  events: {
    generateImage: props<{ prompt: string }>(),
    generateImageSuccess: props<{
      response: GenerateImageResponse
    }>(),
    generateImageFailure: errorProps(),

    generateEnumeration: props<{ prompt: string }>(),
    generateEnumerationSuccess: props<{
      response: GenerateEnumerationResponse
    }>(),
    generateEnumerationFailure: errorProps(),

    generateDocTemplate: props<{ prompt: string }>(),
    generateDocTemplateSuccess: props<{
      response: GenerateDocTemplateResponse
    }>(),
    generateDocTemplateFailure: errorProps(),

    generateNotTemplate: props<{ prompt: string }>(),
    generateNotTemplateSuccess: props<{
      response: GenerateNotTemplateResponse
    }>(),
    generateNotTemplateFailure: errorProps(),

    generateDataModel: props<{ prompt: string }>(),
    generateDataModelSuccess: props<{
      response: GenerateDataModelResponse
    }>(),
    generateDataModelFailure: errorProps(),

    translateSubstitutionTags: props<{ prompt: string }>(),
    translateSubstTagsSuccess: props<{
      response: GenerateSubstTagsResponse
    }>(),
    translateSubstTagsFailure: errorProps(),

    keepEnumerationDraft: emptyProps(),
    keepEnumerationDraftSuccess: props<{ response: any }>(),
    keepEnumerationDraftFailure: errorProps(),
    discardEnumerationDraft: emptyProps(),

    sendFeedback: props<{ payload: SendFeedbackPayload }>(),
    discardDraft: emptyProps(),

    generateDataModelStream: props<{ prompt: string }>(),
    getAnswerEventStream: props<{ response: any }>(),
    reloadDataModelGenerated: emptyProps(),
    keepDraft: emptyProps(),
    keepDraftSuccess: props<{ response: any }>(),
    keepDraftFailure: errorProps(),
  },
})
